<template>
  <div class="cuesus-container">
    <a-row>
      <a-col :span="12" class="col50">
        <a-row class="data-show">
          <a-col :span="6" class="census-title">浏览量</a-col>
          <a-col :span="9" class="census-amount">
            <p>本月浏览量</p>
            <span>{{ visitList.visits_curr_month }}</span>
          </a-col>
          <a-col :span="9" class="census-amount">
            <p>上月浏览量</p>
            <span>{{ visitList.visits_last_month }}</span>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="12" class="col50">
        <a-row class="data-show">
          <a-col :span="6" class="census-title">发稿量</a-col>
          <a-col :span="9" class="census-amount">
            <p>本月发稿量</p>
            <span>{{ publish.publish_curr_month }}</span>
          </a-col>
          <a-col :span="9" class="census-amount">
            <p>上月发稿量</p>
            <span>{{ publish.publish_last_month }}</span>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <div class="seleted-time">
      <h1>请选择时间：</h1>
      <a-range-picker
        @change="onChange"
        :defaultValue="defaultDate"
        :allowClear="false"
        :disabledDate="disabledDate"
        :ranges="{
          今天: [moment(), moment()],
          本月: [moment().startOf('month'), moment()]
        }"
      />
    </div>
    <a-col :span="24" class="col50">
      <a-row class="ranking-item2">
        <a-col :span="3">
          <div class="item-title">
            <span>编辑发稿量</span>
          </div>
        </a-col>
        <a-col :span="21">
          <swiper
            ref="mySwiper"
            :options="swiperOptions"
            class="swiper-container"
          >
            <swiper-slide
              v-for="(item, i) in publish.user_count.lists"
              :key="i"
              class="swiper-list"
            >
              <strong>{{ item.truename }}</strong
              >&nbsp;
              <span>{{ item.nums }}篇</span>
            </swiper-slide>
          </swiper>
        </a-col>
      </a-row>
    </a-col>
    <a-row>
      <a-col :span="12" class="col50">
        <a-row class="ranking-item">
          <div class="item-title">
            稿件浏览量
          </div>
          <div class="item-list">
            <dl>
              <dt><span>浏览量</span>文章标题</dt>
              <dd>
                <ul v-if="visitList.news_top10.lists.length > 0">
                  <template v-for="(item, index) in articleList[articleIndex]">
                    <li :key="index">
                      <span>{{ item.nums }}</span
                      ><a href="">{{ item.title }}</a>
                    </li>
                  </template>
                </ul>
                <template v-else>
                  <a-empty />
                </template>
              </dd>
            </dl>
            <div
              v-if="visitList.news_top10.lists.length > 0"
              style="text-align:right"
            >
              <a-pagination
                :total="pagination.total"
                :current="pagination.current"
                @change="variety"
                showLessItems
              />
            </div>
          </div>
        </a-row>
      </a-col>
      <a-col :span="12" class="col50">
        <a-row>
          <a-col :span="24" class="ranking-item">
            <div class="item-title">
              栏目发稿量
            </div>
            <div class="item-list">
              <dl>
                <dt><span>浏览量</span>栏目名称</dt>
                <dd>
                  <ul v-if="publish.cate_top10.lists != 0">
                    <template
                      v-for="(item, index) in sectionList[sectionIndex]"
                    >
                      <li :key="index">
                        <span>{{ item.nums }}</span
                        >{{ item.catname }}
                      </li>
                    </template>
                  </ul>
                  <template v-else>
                    <a-empty />
                  </template>
                </dd>
              </dl>
              <div
                v-if="publish.cate_top10.lists.length > 0"
                style="text-align:right"
              >
                <a-pagination
                  :total="pagination2.total"
                  :current="pagination2.current"
                  @change="variety2"
                  showLessItems
                />
              </div>
            </div>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'census',
  data() {
    return {
      moment,
      visitList: {
        visits_last_month: 0,
        visits_curr_month: 0,
        news_top10: {
          lists: []
        }
      }, //浏览量
      publish: {
        publish_curr_month: 0,
        publish_last_month: 0,
        cate_top10: {
          lists: []
        },
        user_count: {
          lists: []
        }
      }, //访问量
      articleList: [],
      articleIndex: 0,
      sectionList: [],
      sectionIndex: 0,
      defaultDate: [moment('2019-01-01'), moment('2019-01-07')],
      defaultTime: 7,
      swiperOptions: {
        slidesPerView: '8',
        pagination: false,
        freeMode: true,
        resistanceRatio: 0.6,
        grabCursor: true
      },
      pagination: {
        total: 0,
        current: 1
      },
      pagination2: {
        total: 0,
        current: 1
      }
    };
  },

  created() {
    this.getVisitlist({ page: 1 });
    this.getPublishList();
    this.getCurrentTime();
  },
  mounted() {},
  methods: {
    getCurrentTime() {
      this.defaultDate[1] = moment(moment().format('YYYY-MM-DD'));
      this.defaultDate[0] = moment(
        moment()
          .subtract('days', this.defaultTime - 1)
          .format('YYYY-MM-DD')
      );
    },
    getVisitlist(param = {}) {
      this.$http.post('/api/statis/visit', param).then(res => {
        if (res.data.state == 200) {
          this.visitList = res.data.data;
          this.pagination.total = this.visitList.news_top10.lists.length;
          this.articleList = this.group(this.visitList.news_top10.lists, 10);
        }
      });
    },
    getPublishList(param = {}) {
      this.$http.post('/api/statis/publish', param).then(res => {
        if (res.data.state == 200) {
          this.publish = res.data.data;
          this.pagination2.total = this.publish.cate_top10.lists.length;
          this.sectionList = this.group(this.publish.cate_top10.lists, 10);
        }
      });
    },
    altitude(i) {
      var height =
        this.publish.user_count.lists[i].nums / this.dataChart.Yaxis[0];
      return height * 100 + '%';
    },
    onChange(date, dateString) {
      this.getVisitlist({
        start: dateString[0],
        end: dateString[1]
      });
      this.getPublishList({
        start: dateString[0],
        end: dateString[1]
      });
    },
    disabledDate(current) {
      return (
        (current && moment().subtract(6, 'month') >= current) ||
        current >= moment()
      );
    },
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
      }
      return newArray;
    },
    variety(page, pageSize) {
      this.pagination.current = page;
      this.articleIndex = page - 1;
    },
    variety2(page, pageSize) {
      this.pagination2.current = page;
      this.sectionIndex = page - 1;
    }
  }
};
</script>

<style scoped>
.cuesus-container {
  position: absolute;
  left: 0;
  top: 42px;
  right: 0;
  bottom: 0;
  background: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px 10px;
}
.col50 {
  padding: 0 10px;
}
.data-show {
  height: 100px;
  border: 1px solid #ddd;
}
.census-title {
  font-weight: bold;
  padding: 20px;
  font-size: 16px;
  color: #409eff;
}
.census-amount {
  padding: 20px 0;
  font-size: 15px;
}
.census-amount p {
  margin-bottom: 0;
  line-height: 25px;
}
.census-amount span {
  font-weight: bold;
  font-size: 40px;
  color: #33cf1e;
  line-height: 30px;
}
.seleted-time {
  height: 92px;
  clear: both;
  padding: 30px;
}
.seleted-time > h1 {
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  display: inline-block;
  color: #666;
  padding-right: 15px;
}
.ranking-item {
  border: 1px solid #ddd;
  min-height: 500px;
  padding: 10px 20px;
}
.ranking-item2 {
  border: 1px solid #ddd;
  min-height: 50px;
  padding: 10px 20px;
  margin-bottom: 20px;
}
.item-title {
  font-size: 16px;
  font-weight: bold;
  color: #409eff;
}
.item-list dt {
  height: 55px;
  line-height: 45px;
  overflow: hidden;
  color: #888;
  padding: 10px 0;
}
.item-list dt span {
  float: right;
}
.item-list * {
  margin: 0;
}
.item-list dd li {
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  overflow: hidden;
}
.item-list dd li span {
  float: right;
}
.item-list dd li a {
  color: #282828;
}
/* .item-list2 {
  width: 100%;
  display: flex;
  white-space: nowrap;
  float: left;
} */
.swiper-list {
  font-size: 16px;
  min-width: 140px;
  text-align: center;
}
/*css柱状图*/
.histogram-container {
  position: relative;
  margin-left: 50px;
  margin-top: 30px;
  margin-bottom: 25px;
}
.histogram-bg-line {
  border: #999 solid;
  border-width: 0 1px 1px 1px;
  border-right-color: #eee;
  overflow: hidden;
  width: 99%;
}
.histogram-bg-line ul {
  overflow: hidden;
  border: #eee solid;
  border-width: 1px 0 0 0;
  margin: 0;
}
.histogram-bg-line li {
  float: left;
  width: 20%; /*根据.histogram-bg-line下的ul里面li标签的个数来控制比例*/
  overflow: hidden;
}
.histogram-bg-line li div {
  border-right: 1px #eee solid;
}
.histogram-content {
  position: absolute;
  left: 0px;
  top: 0;
  width: 99%;
  height: 100%;
}
.histogram-content ul {
  height: 100%;
  margin: 0;
}
.histogram-content li {
  float: left;
  height: 100%;
  width: 20%; /*根据直方图的个数来控制这个width比例*/
  text-align: center;
  position: relative;
}
.histogram-box {
  position: relative;
  display: inline-block;
  height: 100%;
  width: 26px;
}
.histogram-content li a {
  position: absolute;
  bottom: 0;
  right: 0;
  display: block;
  width: 25px;
}
.histogram-content li .name {
  position: absolute;
  bottom: -30px;
  left: 0px;
  white-space: nowrap;
  display: inline-block;
  width: 100%;
  font-size: 12px;
}
.histogram-y {
  position: absolute;
  left: -60px;
  top: -10px;
  font: 12px/1.8 verdana, arial;
}
.histogram-y li {
  text-align: right;
  width: 55px;
  padding-right: 5px;
  color: #333;
}
.histogram-bg-line li div,
.histogram-y li {
  height: 75px; /*控制单元格的高度及百分比的高度，使百分数与线条对齐*/
}
.histogram-box .aOne {
  background: linear-gradient(to bottom, #a3c8fc, #5196d7);
}
.histogram-bg-line div {
  line-height: 30px;
}
.histogram-bg-line div img {
  position: relative;
  top: 3px;
  padding-left: 10px;
}
</style>
